module.exports = __webpack_public_path__ + "img/background.64ee8295.png";